// Splide (v4.1.4) sets role="group"/"tabpanel" + aria-roledescription="slide" on each .splide__slide
// while its own .splide__list carries role="presentation" (see Elements.ts / Slides/Slide.ts in
// @splidejs/splide). Per the ARIA-in-HTML presentational-children rules, a role on a child of a
// role="presentation" list is flagged as an unsupported ARIA state/property by strict validators —
// tracked upstream as https://github.com/dequelabs/axe-core/issues/4910. Splide only sets these
// once, inside each slide's own mount(), so a single pass right after Splide's .mount() is enough.
export function stripSplideSlideRoleAttributes(root: HTMLElement): void {
    root.querySelectorAll<HTMLElement>('.splide__slide').forEach((slide) => {
        slide.removeAttribute('role');
        slide.removeAttribute('aria-roledescription');
    });
}
